// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './AppRoutes'; // ✅ import the new route component
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div style={{ backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
      <AuthProvider>
        <Router>
          <AppRoutes /> {/* ✅ Use it here, NOT inside <Routes> */}
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
